module.exports = __webpack_public_path__ + "assets/images/yellow2_a0f32b27c9aa7d15d6baef7f508d6da4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help/yellow2.png
// module id = 154
// module chunks = 0